module.exports = __webpack_public_path__ + "img/backgroundCopy.b4e8dcbe.png";